// =============================================================================
// Factory — Create a pre-configured ApiClient for each app context
// =============================================================================

import { ApiClient } from './client';
import type { ApiClientConfig } from './types';

/**
 * Creates an ApiClient instance with sensible defaults.
 * Each frontend app calls this once at startup.
 *
 * @example
 * ```ts
 * // In portal app
 * export const api = createApiClient({
 *   baseUrl: import.meta.env.VITE_API_URL,
 *   onUnauthorized: async () => {
 *     const ok = await refreshToken();
 *     if (!ok) { window.location.href = '/login'; }
 *     return ok;
 *   },
 * });
 *
 * // Usage
 * const orders = await api.get<PaginatedResponse<Order>>('/orders', {
 *   query: { page: 1, limit: 20 },
 * });
 * ```
 */
export function createApiClient(config: ApiClientConfig): ApiClient {
  return new ApiClient(config);
}
